module.exports = __webpack_public_path__ + "images/no-image-placeholder.c143b3cd.png";